module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-2-photo-1-bb42b4f46b4ab5e94dd71357a180dc21.webp";